<template>
  <div id="extra-component-chartist-demo">
      <div class="vx-row" v-show="showAppSection">
          <h4 class="vx-col w-full">{{ getResourcesWithStatisticsFeature('app').length === 1 ? $t('dashboard.app') : $t('dashboard.apps') }}</h4>
          <vs-divider class="vx-col w-full"/>

          <dashboard-statistics-slider
            resource-type="app"
            :statistic-key="statisticKey"
            @loaded="showAppSection = true"
            v-for="statisticKey in statisticsKeys('app')"
            :key="statisticKey"
          />
      </div>

      <div class="vx-row" v-show="showResortSection">
          <h4 class="vx-col w-full">{{ getResourcesWithStatisticsFeature('resort').length === 1 ? $t('dashboard.resort') : $t('dashboard.resorts') }}</h4>
          <vs-divider class="vx-col w-full"/>
          <dashboard-statistics-slider
            resource-type="resort"
            :statistic-key="statisticKey"
            @loaded="showResortSection = true"
            v-for="statisticKey in statisticsKeys('resort')"
            :key="statisticKey"
          />
      </div>
  </div>
</template>

<script>

import { getResourcesWithStatisticsFeature} from "@/modules/Statistics/Services/StatisticsService";
import StatisticCard from "@/modules/Statistics/Components/StatisticCard";
import { mapGetters } from "vuex";
import DashboardStatisticsSlider from "@/modules/Statistics/Components/DashboardStatisticsSlider";

export default {
  data () {
    return {
      getResourcesWithStatisticsFeature: getResourcesWithStatisticsFeature,
      showAppSection: false,
      showResortSection: false,
    }
  },
  computed: {
    ...mapGetters("statistics", ["statisticsKeys"]),
  },
  components: {
    DashboardStatisticsSlider,
    StatisticCard
  },

}
</script>
